import React, { useState }  from 'react';

import { useDispatch } from 'react-redux'

import { create } from '../redux/reducers'

import MovieThumb from './MovieThumb';
import Icon from '../compUtils/Icon';


function MovieThumbInput(props) {
    const dispatch = useDispatch()
    const [createState, setCreateState] = useState('NOCREATE')

    const handleFiles = (files) => {
        console.log("redaing file")
        const file = files[0]
        const reader = new FileReader()
        reader.addEventListener('load', (event) => {
            if (file.size > 50000)
                    {
                    alert("file shall be < 50 ko")
                    return
                    }
            console.log("file read")
            dispatch(create("/api/images/", { "name": file.name, "source": event.target.result }, (result) => {
                setCreateState("CREATED")
                const clone = { ...props.objectInputState }
                clone.thumbnail = result.id
                props.setObjectInputState(clone)
            }))
            setCreateState("CREATEPENDING")
        })

        reader.readAsDataURL(file)
    }

    return (
        <div>
            {
                createState === "CREATED" ?
                    <MovieThumb movieID={0} imageId={props.objectInputState.thumbnail}/>
                    :
                    ""
            }
            <div class="file">
                <label class="file-label">
                    <input class="file-input" type="file" accept=".jpg" name="resume" onChange={(e) => handleFiles(e.target.files)} />
                    <span class="file-cta">
                        <span class="file-icon">
                            <Icon name="upload" />
                        </span>
                        <span class="file-label">
                            Image…
                        </span>
                    </span>
                </label>
            </div>

        </div>

    );
}

export default MovieThumbInput;
